export default __webpack_public_path__ + "static/media/delete-modal-icon.521fe9f1.svg";